import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';


class MyMenu extends Component {
    state = {
        value: 0,
    };

    logout = () => {
        console.log('logout')
        this.props.logout();
    }

    render() {
        return (
    <div>

                <Drawer
                    variant="permanent"
                    anchor="left">
                    <ListItem >
                        < img src="images/amplia_title_nobackground.png"
                            height="40" alt="AMPLIA logo"/>
                    </ListItem>
                    <ListItem
                        style={{ width: 260 }}>
                        <ListItemText primary={"Welcome " + this.props.name} />
                    </ListItem>
                    < Divider style={{ color: "white" }} />
                    <ListItem button component={Link} to={'/'}>
                        < ListItemText secondary="Home" />
                    </ListItem>
                    <ListItem button component={Link} to={'/payments'}>
                        < ListItemText secondary="Payment History" />
                    </ListItem>
                    <ListItem button  component={Link} to={'/invoices'}>
                        < ListItemText secondary="View Bills" />
                    </ListItem>
                    <ListItem button component={Link} to={'/payment'}>
                        < ListItemText secondary="Make Payment" />
                    </ListItem>
                    <ListItem  button component={Link} to={'/wifi'}>
                        < ListItemText secondary="Manage your WiFi" />
                    </ListItem>
                    <ListItem  button component={Link} to={'/tat'}>
                        < ListItemText secondary="Tips & Tricks" />
                    </ListItem>
                    <ListItem button  onClick={this.logout}>
                        <ListItemText secondary="Logout" />
                    </ListItem>
                    <Divider />
                </Drawer>
            </div>
        );
    }
}


export default withRouter(MyMenu)